import React, { useState } from "react";
import axios from "axios";

const placeholderSVG = (
  <svg width="350" height="350" viewBox="0 0 350 350" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="350" height="350" rx="40" fill="#E9E6FD"/>
    <circle cx="175" cy="175" r="90" fill="#B7A7F7"/>
    <rect x="110" y="140" width="130" height="70" rx="15" fill="#fff"/>
    <rect x="140" y="170" width="70" height="10" rx="5" fill="#B7A7F7"/>
    <circle cx="175" cy="175" r="25" fill="#E9E6FD"/>
    <rect x="160" y="200" width="30" height="8" rx="4" fill="#B7A7F7"/>
  </svg>
);

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("user");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [remember, setRemember] = useState(false);

  const apiBase = process.env.REACT_APP_BACKEND_URL || '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${apiBase}/api/login`, { username, password, role });
      onLogin(res.data.token, res.data.role, res.data.username);
    } catch (err) {
      setError(
        err.response?.data?.detail || "Login failed. Please check your credentials."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen w-full bg-[#FAFAF6] overflow-hidden" style={{height: '100vh'}}>
      {/* Left: Login Form */}
      <div className="flex flex-col justify-center w-full max-w-xl px-12 py-10 h-full">
        <div className="mb-8">
          <span className="inline-block font-bold text-lg text-cyan-500 mb-2">ArtaSupport</span>
          <h1 className="text-3xl font-extrabold mb-2 text-[#253439]">Hello! Welcome Back</h1>
        </div>
        <form onSubmit={handleSubmit} className="w-full">
          <div className="flex mb-6">
            <button
              type="button"
              className={`flex-1 py-2 rounded-l-lg font-semibold border ${role === "user" ? "bg-cyan-500 text-white" : "bg-gray-100 text-gray-700"}`}
              onClick={() => setRole("user")}
            >
              User
            </button>
            <button
              type="button"
              className={`flex-1 py-2 rounded-r-lg font-semibold border-l-0 border ${role === "agent" ? "bg-cyan-500 text-white" : "bg-gray-100 text-gray-700"}`}
              onClick={() => setRole("agent")}
            >
              Agent
            </button>
          </div>
          <div className="mb-4">
            <input
              type="text"
              className="w-full border rounded px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-cyan-500 bg-[#FAFAF6]"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="mb-4">
            <input
              type="password"
              className="w-full border rounded px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-cyan-500 bg-[#FAFAF6]"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="flex items-center justify-between mb-6">
            <label className="flex items-center text-sm">
              <input
                type="checkbox"
                className="mr-2 accent-cyan-500"
                checked={remember}
                onChange={() => setRemember((v) => !v)}
              />
              Remember me
            </label>
            <button
              type="button"
              className="text-cyan-500 text-sm hover:underline bg-transparent border-none p-0 m-0 cursor-pointer"
              tabIndex={0}
            >
              Forgot Password?
            </button>
          </div>
          {error && <div className="mb-4 text-red-600 text-sm">{error}</div>}
          <button
            type="submit"
            className="w-full bg-cyan-500 hover:bg-cyan-600 text-white font-semibold py-3 rounded-lg text-base transition"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <div className="mt-8 text-center text-sm text-gray-500">
          Don't have an account? <button type="button" className="text-cyan-500 font-semibold hover:underline bg-transparent border-none p-0 m-0 cursor-pointer" tabIndex={0}>Sign Up</button>
        </div>
      </div>
      {/* Right: Illustration */}
      <a href="./discover" className="hidden md:flex flex-1 items-center justify-center bg-[#FAFAF6] h-full">
         <img
            src="/Arta_login_page.png"
            alt="Arta Login Illustration"
            className="w-full h-full object-cover rounded-l-3xl"
            style={{maxHeight: '100vh'}}
          />
      </a>
    </div>
  );
};

export default Login; 
